var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecurrence(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#2378E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1111 16.1359V14.4621L8.33228 17.8497L14.1111 21.4365V18.8859C16.7255 18.5989 18.5216 16.1359 19.0928 14.9403C20.6551 11.3694 19.0264 8.11202 18.0168 6.92969L16.0639 8.92238C18.6783 12.3976 15.8514 15.1794 14.1111 16.1359Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0518 8.04181L10.1043 9.71485L15.7741 6.14789L9.88575 2.74384L9.96566 5.29324C7.36152 5.66195 5.64348 8.17998 5.10997 9.39291C3.66034 13.011 5.39029 16.2158 6.43646 17.3659L8.32592 15.313C5.60391 11.9214 8.34234 9.05236 10.0518 8.04181Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurrence);
export default __webpack_public_path__ + "static/media/recurrence.2653d5f8a67cdc6838aed02b52a5d2c1.svg";
export { ForwardRef as ReactComponent };